import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Radio, RadioGroup, FormControl, FormControlLabel } from '@material-ui/core';

class FHERadio extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        customClasses: PropTypes.string,
        choices: PropTypes.array.isRequired,
        disabled: PropTypes.bool.isRequired,
        row: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        title: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        value: PropTypes.string
    };

    static defaultProps = {
        value: '',
        customClasses: null,
        row: false
    };

    renderRadios() {
        const { choices, disabled } = this.props;
        return choices.map(({ value, label }) => (
            <FormControlLabel disabled={disabled} key={value} value={value} control={<Radio color="primary" />} label={label} />
        ));
    }

    render() {
        const { classes, customClasses, title, onChange, value, name, row } = this.props;

        return (
            <FormControl component="fieldset" className={`${classes.FHERadioContainer} ${customClasses}`}>
                <div className={classes.title}>{title}</div>
                <RadioGroup className={row ? classes.row : ''} name={name} value={value} onChange={onChange}>
                    {this.renderRadios()}
                </RadioGroup>
            </FormControl>
        );
    }
}

const styles = () => ({
    row: {
        flexDirection: 'row'
    },
    title: {
        fontSize: '0.9em',
        color: '#858585',
        marginBottom: 2,
        overflowWrap: 'break-word'
    },
    FHERadioContainer: {
        top: 11
    }
});

export default withStyles(styles, { withTheme: true })(FHERadio);



// WEBPACK FOOTER //
// ./data/components/FHERadio.js